export class TealiumClickModel {
    constructor(opts) {
        let o = opts || {};
        this.tealium_event = o.tealium_event || 'mediathek-clicks';
        this.link_category = o.link_category || 'mediathek';
        this.link_name = o.link_name || 'video';
        this.link_action = o.link_action || 'click';
        this.link_value = o.link_value || '';
    }

    updateWithVideoData(videoData) {
        if (videoData === undefined) {
            return;
        }
        let videoId = videoData.videoId || '';
        let caption = videoData.caption || '';
        this.link_name = `video-${videoId.replace('Z-', '')}`;
        this.link_value = caption;
    }

    getUtagClickOptions() {
        return {
            tealium_event: this.tealium_event,
            link_category: this.link_category,
            link_name: this.link_name,
            link_action: this.link_action,
            link_value: this.link_value
        }
    }
}